import {Analytics_Enabled} from '../config';

const GTM_ID = 'GTM-M27QQ8QB';

const getCspNonce = () =>
  document.querySelector('meta[name="csp-nonce"]')?.getAttribute('content');

const setScriptNonce = (node: Node, nonce: string) => {
  if (node instanceof HTMLScriptElement && !node.nonce) {
    node.setAttribute('nonce', nonce);
  }
};

const installScriptNoncePropagation = (nonce?: string | null) => {
  if (!nonce || (window as any).__GTM_NONCE_PROPAGATION_INSTALLED__) {
    return;
  }

  (window as any).__GTM_NONCE_PROPAGATION_INSTALLED__ = true;

  const originalCreateElement = Document.prototype.createElement;
  Document.prototype.createElement = function createElement(
    tagName: string,
    options?: ElementCreationOptions
  ) {
    const element = originalCreateElement.call(this, tagName, options);

    if (tagName.toLowerCase() === 'script') {
      element.setAttribute('nonce', nonce);
    }

    return element;
  };

  const originalAppendChild = Node.prototype.appendChild;
  Node.prototype.appendChild = function appendChild<T extends Node>(node: T): T {
    setScriptNonce(node, nonce);

    return originalAppendChild.call(this, node) as T;
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function insertBefore<T extends Node>(
    node: T,
    child: Node | null
  ): T {
    setScriptNonce(node, nonce);

    return originalInsertBefore.call(this, node, child) as T;
  };
};

export const initGTM = () => {
  if (!Analytics_Enabled) {
    console.info('GTM disabled');
    return;
  }

  if (typeof window === 'undefined') return;

  if ((window as any).__GTM_INITIALIZED__) return;
  (window as any).__GTM_INITIALIZED__ = true;

  const cspNonce = getCspNonce();
  installScriptNoncePropagation(cspNonce);

  (window as any).dataLayer = (window as any).dataLayer || [];
  (window as any).dataLayer.push({
    'gtm.start': new Date().getTime(),
    cspNonce,
    event: 'gtm.js',
  });

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;

  if (cspNonce) {
    script.setAttribute('nonce', cspNonce);
  }

  document.head.appendChild(script);
};
